<template>
  <v-navigation-drawer v-model="mini" app style="z-index: 100;">
    <v-list dense>
      <v-list-item
        style="height:30px;border-bottom: 1px solid rgba(0, 0, 0, 0.05);"
        class="pb-5"
      >
        <div class="image-logo" v-if="status === 'YOMART'">
          <v-img class="image-nav" :src="yomartLogo" />
        </div>
        <div class="image-logo" v-else>
          <v-img class="image-nav" :src="yotodoLogo" />
        </div>
      </v-list-item>
    </v-list>

    <v-list dense>
      <v-list-item
        link
        v-for="(sidebarItem, i) in sidebarData"
        :key="i"
        :to="sidebarItem.to"
      >
        <v-list-item-icon class="pr-0 mr-3">
          <v-icon color="#5c6980">{{ sidebarItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ sidebarItem.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-subheader class="pl-4 text-center" v-if="mini !== true"
        >Main Menu</v-subheader
      >
      <div v-if="showItems">
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </div>
      <div v-else>
        <div v-for="(sidebarItem, j) in itemMenus" :key="j">
          <v-list-item
            link
            v-if="sidebarItem.name !== 'Master Transisi Karir'"
            :to="sidebarItem.to"
          >
            <v-list-item-icon class="pr-0 mr-3">
              <v-icon :color="sidebarItem.color">{{ sidebarItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ sidebarItem.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
import { sidebar, sidebar2, mainMenu, mainMenuGuest } from "@/router/nav";
const { mapState } = createNamespacedHelpers("system");
export default {
  name: "AppSidebar",
  data() {
    return {
      showItems: false,
      drawer: null,
      itemMenus: [],
      tempData: [],
      status: null,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    // window.addEventListener("resize", this.handleResize);
    // window.addEventListener("resize", this.minisize);
    // this.handleResize();
    // this.minisize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.minisize);
  },
  mounted() {
    const temp_user = JSON.parse(Cookies.get("userdata_login"));
    this.$store.commit("system/SET_IDMENU", temp_user.data.user_type_id);
    this.loadData();
  },
  computed: {
    yotodoLogo() {
      return require("@/assets/img/logo/yogya-logo.png");
    },
    yomartLogo() {
      return require("@/assets/img/logo/logo-yomart.jpg");
    },
    sidebarData() {
      return sidebar;
    },
    sidebarData2() {
      return sidebar2;
    },
    mainMenuData() {
      const temp_user = JSON.parse(Cookies.get("userdata_login"));
      mainMenu.forEach(item => {
        if (temp_user.data.user_type === item.role) {
          this.data = mainMenu;
        } else {
          this.data = mainMenuGuest;
        }
      });
      return this.data;
    },
    ...mapState(["mini", "res_menu"])
  },
  watch: {},
  methods: {
    async loadData() {
      this.showItems = true;
      try {
        let res = await this.$store.dispatch("system/getMenus");
        if (res.status === 200) {
          this.showItems = false;
          this.itemMenus = res.data.data.menus;
          this.status = res.data.data.company_name;
        }
      } catch (e) {
        this.showItems = false;
      }
    },
    changeMini() {
      this.$store.commit("system/SET_MINI", (this.mini = !this.mini));
    },
    minisize() {
      if (this.window.width <= 1270) {
        this.mini = true;
      } else {
        this.mini = false;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>

<style lang="scss"></style>
